import * as z from 'zod';
import * as ba from './base';
import { NotificationOptions } from '../modal';
import { SCRIPT_SCHEMA } from '../scripting';
import { isComponentContext, assertVueComponent } from '../helpers';

export interface ToastMessageActionArgs extends NotificationOptions {}

export class ToastMessageAction extends ba.Action<ToastMessageActionArgs, any> {
  static get manifest() {
    return {
      name: 'toastMessage',
      schema: z.object({
        message: z.union([z.string(), SCRIPT_SCHEMA()]),
        title: z.union([z.string(), SCRIPT_SCHEMA()]).optional(),
        variant: z.union([z.string(), SCRIPT_SCHEMA()]).optional(),
      }),
    };
  }

  async handle(event: ba.ActionEvent, args: ToastMessageActionArgs) {
    assertVueComponent(event.component);
    const notification = (event.component as any).$notification;
    if (notification) {
      notification.show(args);
    }
  }
}

export interface NotificationActionArgs {
  message: string;
  title?: string;
  variant?: string;
}

export class NotificationAction extends ba.Action<NotificationActionArgs, any> {
  static get manifest() {
    return {
      name: 'notification',
      schema: z.object({
        message: z.union([z.string(), SCRIPT_SCHEMA()]),
        title: z.union([z.string(), SCRIPT_SCHEMA()]).optional(),
        variant: z.union([z.string(), SCRIPT_SCHEMA()]).optional(),
      }),
    };
  }

  async handle(event: ba.ActionEvent, args: NotificationActionArgs) {
    assertVueComponent(event.component);
    const notification = (event.component as any).$notification;
    if (notification) {
      notification.show(args);
    }
  }
}
